exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".bread-content {\n  padding: 5px 0 !important;\n}\n.ant-breadcrumb {\n  font-size: 12px !important;\n}\n", ""]);

// exports
